import React from 'react'
import { fragThing } from '../../utils/fragments'
import { mapThing, mapMetaData } from '../../utils/mapper'
import MetaData from '../../components/metadata'
import ThingContent from '../../components/thing'

const Thing = props => {
  const metadata = mapMetaData(props.data.thing)
  const thing = mapThing(props.data.thing)
  return (
    <ThingContent thing={thing} metadata={metadata}/>
  )
}

export default Thing

export const query = graphql`
  query thingQuery($id: String!) {
    thing: prismicCtThing(id: { eq: $id }) {
        ...thing
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/things/thing.js